import { Formik, FormikProps } from "formik"
import { Paper, Typography } from "@mui/material"

import { i18nPalletCalc } from "./i18n"
import { useTranslateSingle } from "../../../hooks/translate"
import { CalcPalletsMobileForm } from "./mobile/CalcPalletsMobileForm"
import { CalcPalletsDesktopForm } from "./desktop/CalcPalletsDesktopForm"
import { DeviceComponents, useResponsive } from "../../../hooks/useResponsive"
import { DeviceStrings, useResponsiveString } from "../../../hooks/useResponsiveString"

export interface IPalletCalcFormValues {
    palletsCount: number
    fromCountry: string
    toCountry: string
    fromRegion: string
    toRegion: string
}

function FormComponent(props: FormikProps<IPalletCalcFormValues>): JSX.Element {
    const components = (props: FormikProps<IPalletCalcFormValues>) => ({
        mobile: <CalcPalletsMobileForm {...props} />,
        smallDesktop: <CalcPalletsDesktopForm {...props} />,
    }) as DeviceComponents

    const formComponent = components(props)

    return useResponsive(formComponent)
}

export function CalcPalletsForm(): JSX.Element {
    const title = useTranslateSingle(i18nPalletCalc.title)

    const classNames = {
        mobile: 'price-calc-pallets-container-mobile',
        smallDesktop: 'price-calc-pallets-container',
    } as DeviceStrings

    const className = useResponsiveString(classNames)

    return (
        <div className={className}>
            <Paper className="price-calc-form-paper" elevation={3}>
                <Typography variant="h5" className="price-calc-header">
                    {title}
                </Typography>
                <Formik
                    initialValues={{
                        palletsCount: 1,
                        showRequestButton: true,
                        fromCountry: 'Italy',
                        fromRegion: 'Rome',
                        toCountry: 'Bulgaria',
                        toRegion: 'Sofia',
                    } as IPalletCalcFormValues}
                    onSubmit={(values: any, { setSubmitting, setFieldValue }) => {
                        setSubmitting(true)

                        const { fromRegion, toRegion } = values
                        const noAutoPriceFromRegions = fromRegion !== 'Sofia' && fromRegion !== 'Rome'
                        const noAutoPriceToRegions = toRegion !== 'Sofia' && toRegion !== 'Rome'
                        if (noAutoPriceFromRegions || noAutoPriceToRegions) {
                            setFieldValue('price', 0)
                            return
                        }

                        // const totalPrice = calculateTransportationPrice(values.packages, prices)
                        const totalPrice = 0 // TODO: make pallet calc automation 
                        setFieldValue('price', totalPrice)
                    }}
                >
                    {(props) => <FormComponent {...props} />}
                </Formik>
            </Paper>
        </div>
    )
}